const APP_BASE = ''
export const URL_CONST = {
  ROOT: '/',
  ORDERS: '/pedidos',
  ORDERS_SIMULATE: '/simula',
  ORDERS_UNFOLD: '/resumo',
  ORDERS_SUCCESS: '/sucesso',
  MANAGE: '/gerenciar',
  MANAGE_ORDER: '/gerenciar/pedido',
  MANAGE_OV: '/gerenciar/ordem-venda',
  NEW_ORDERS: '/pedidos/novo',
  LOGIN: '/login',
  EXPIREDPASSWORD: '/esqueci-minha-senha',
  ND: '/negociacao-diferenciada',
  STOCK_REPORT: '/relatorio-estoque',
  EXTRA_VOLUME: '/volume-extra',
  BACKOFFICE: '/backoffice',
  APPROVAL_RANGES: '/alcadas',
  LEAD_TIMES: '/lead-times',
  KEY_ACCOUNTS: '/key-accounts'
}
class Route<T> {
  public base: string
  public children: T

  constructor(base: string, children: T) {
    this.base = base
    this.children = children
  }

  private linkFactory = (key?: keyof T, childToGet?: T[keyof T]) => {
    if (key) {
      const child = this.children[key]
      let childAsPath = child instanceof Route ? child.base : child
      if (child instanceof Route && childToGet) {
        childAsPath = `${child.base}\\${child.children[childToGet]}`
      }

      return `${childAsPath}`.replace(/\//g, '').replace(/\\/g, '/')
    }
  }

  public getLink = (key?: keyof T, child?: T[keyof T]) => {
    let link = ''
    const baseUrl = this.base.replace(/\//g, '')

    if (APP_BASE) {
      link += `/${APP_BASE}`
    }

    if (baseUrl) {
      link += `/${baseUrl}`
    }

    link += `/${this.linkFactory(key, child)}`

    return link
  }
}

export const ROUTES = {
  app: new Route('/', {
    openPage: 'pagina-aberta',
    error: 'error'
  }),
  forgetPassword: new Route('/esqueci-minha-senha', {
    validateCode: 'validar-codigo',
    resetPassword: 'redefinir-senha',
    changedPassword: 'senha-alterada'
  }),
  login: new Route('/login', {}),
  orders: new Route('/pedidos', {
    new: new Route('/novo', {}),
    batchOrders: new Route('/lote', {
      international: new Route('/internacional', {}),
      franchises: new Route('/franquias', {})
    }),
    orderDetail: new Route('/:orderNumber', {
      orderMaterials: '/:materialNumber',
      orderSimulate: '/simula'
    })
  }),
  manage: new Route('/gerenciar', {
    order: new Route('/pedido', {
      orderDetail: new Route('/:orderNumber', {
        orderMaterial: new Route('/:materialNumber', {})
      })
    }),
    ov: new Route('/ordem-venda', {
      ovDetail: new Route('/:ovNumber', {
        justificar: new Route('/justificar', {}),
        ovMaterial: new Route('/:materialNumber', {
          ovMaterialItem: '/:itemNumber'
        })
      })
    })
  }),
  nd: new Route('/negociacao-diferenciada', {}),
  stock_report: new Route(URL_CONST.STOCK_REPORT, {}),
  extra_volume: new Route(URL_CONST.EXTRA_VOLUME, {}),
  backoffice: new Route(URL_CONST.BACKOFFICE, {
    ranges: new Route(URL_CONST.APPROVAL_RANGES, {}),
    lead_times: new Route(URL_CONST.LEAD_TIMES, {}),
    key_accounts: new Route(URL_CONST.KEY_ACCOUNTS, {})
  })
} as const
